import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Icon } from '@panel/commons/lib/Icon/Icon';
import { BodyText, Headings } from '@panel/commons/lib/typography';
import { useTranslation } from 'react-i18next';
import { PrimaryBtn } from '@panel/commons/lib/Button';
import { useSelector } from 'react-redux';
import { CompanyPubrSelectors } from '@panel/usuarios/src/store/ducks/myCompany';

const MessageWrapper = styled.div`
  padding: 0px 16px 16px;
  text-align: center;
  width: 100%;
  max-width: 100%;
  padding-top: ${({ border }) => (border ? '8px' : '0px')};
  margin: auto;

  @media ${({ theme }) => theme.v2.breakpoints.Min.desktop} {
    margin: 0;
    max-width: 400px;
    padding: 0px 8px 8px;
    width: 368px;
  }
`;

const IconWrapper = styled.div`
  display: block;
  margin: 8px 0px;
  width: 100%;
  height: 50px;
`;

const Title = styled(Headings).attrs({ size: 400 })`
  display: block;
  margin: auto;
  padding-bottom: 8px;
  width: 260px;
  white-space: break-spaces;
`;

const SubTitle = styled(BodyText).attrs({ size: 200 })`
  display: block;
  padding-bottom: 8px;
  white-space: break-spaces;
`;

const RedirectMessage = ({ isPublisherMasked = false, link = null, handleAction }) => {
  const { t } = useTranslation();
  const { autologin, fetchedAutologin } = useSelector(CompanyPubrSelectors.getCompanyPubr);

  useEffect(() => {
    if (fetchedAutologin) {
      handleAction(true);
      setTimeout(() => {
        const uri = autologin;
        window.location = uri.replace('configuracion.bum', 'publicar.bum');
      }, 6200);
    }

    if (!isPublisherMasked && link) {
      window.location = link;
    }
  }, [handleAction, isPublisherMasked, link, autologin, fetchedAutologin]);

  const handleClick = () => {
    if (fetchedAutologin && autologin) {
      const uri = autologin;
      window.location = uri.replace('configuracion.bum', 'publicar.bum');
    }
  };

  return (
    <MessageWrapper border={!fetchedAutologin}>
      <IconWrapper>
        <Icon name='timer' size={500} float='none' />
      </IconWrapper>
      <Title>{t('panel.header.modal.publisherRedirect.title')}</Title>
      <SubTitle>{t('panel.header.modal.publisherRedirect.subtitle')}</SubTitle>
      <PrimaryBtn size={100} onClick={handleClick} disabled={!fetchedAutologin}>
        {t('panel.header.modal.publisherRedirect.cta')}
      </PrimaryBtn>
    </MessageWrapper>
  );
};

export { RedirectMessage };
